"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VOCDONI_CSP_CENSUSES = exports.VOCDONI_SUPPORTED_CENSUSES = exports.VOCDONI_CENSUS_CSP_BLINDNS = exports.VOCDONI_CENSUS_CSP_NBNS = exports.VOCDONI_CENSUS_OFFCHAIN = void 0;
exports.VOCDONI_CENSUS_OFFCHAIN = 'offchain';
exports.VOCDONI_CENSUS_CSP_NBNS = 'csp-non-blinded-non-salted';
exports.VOCDONI_CENSUS_CSP_BLINDNS = 'csp-blinded-non-salted';
exports.VOCDONI_SUPPORTED_CENSUSES = [exports.VOCDONI_CENSUS_OFFCHAIN, exports.VOCDONI_CENSUS_CSP_NBNS, exports.VOCDONI_CENSUS_CSP_BLINDNS];
exports.VOCDONI_CSP_CENSUSES = [exports.VOCDONI_CENSUS_CSP_NBNS, exports.VOCDONI_CENSUS_CSP_BLINDNS];
